module.exports = __webpack_public_path__ + "static/media/plaque_bdl_2024.1bead85a.png";